// interfaces/types
import type { StateTree } from '@makemydeal/dr-dash-types';

export const getLead = (state: StateTree) => {
    return state.lead;
};
